import { render, staticRenderFns } from "./SmscTable.vue?vue&type=template&id=70c69aef&"
import script from "./SmscTable.vue?vue&type=script&lang=js&"
export * from "./SmscTable.vue?vue&type=script&lang=js&"
import style0 from "./SmscTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports